var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "#28A745"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36003 6.31906H11.2371V10.2017H12.5382V2.46133H11.2371V5.26657H9.36003V6.31906ZM6.91528 6.52624C7.37523 7.52486 8.21224 8.33702 9.39733 8.73481L10.0479 7.70304C8.41114 7.16022 7.55755 5.84254 7.55755 4.57044V4.27624H9.74954V3.22376H4.02302V4.27624H6.23158V4.56215C6.23158 5.97099 5.32827 7.35497 3.6418 7.90608L4.31307 8.96271C5.5686 8.53177 6.44705 7.63674 6.91528 6.52624ZM6.89042 9.51796H5.58932V12.837H12.8034V11.7804H6.89042V9.51796Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJIcon);
export default __webpack_public_path__ + "static/media/JIcon.1943d242bcfa9e290fc0f0c83b113265.svg";
export { ForwardRef as ReactComponent };